import { Flag } from "@medbillai/utils/flag";
import type { ScreenViewProps } from "../../components/ScreenView";
import { useBoolVariation } from "../../lib/flag";
import { HomeContent } from "./components/HomeContent";
import { LegacyHomeContent } from "./components/LegacyHomeContent";
export type HomeScreenProps = {
  screenViewProps?: Omit<ScreenViewProps, "children">;
};
export function HomeScreen({
  screenViewProps
}: HomeScreenProps) {
  const redesignEnabled = useBoolVariation(Flag.CASES_HOME_REDESIGN, false);
  return redesignEnabled ? <HomeContent screenViewProps={screenViewProps} data-sentry-element="HomeContent" data-sentry-component="HomeScreen" data-sentry-source-file="screen.tsx" /> : <LegacyHomeContent screenViewProps={screenViewProps} data-sentry-element="LegacyHomeContent" data-sentry-component="HomeScreen" data-sentry-source-file="screen.tsx" />;
}